<!-- <tt-card>
    <tt-file-data-viewer (ttDataChange)="log($event)"></tt-file-data-viewer>
</tt-card> -->
<!-- <input type="file" (change)="onFileSelected($event)" accept=".ifc" />
<bim-world></bim-world>
<div style="display: flex; flex: 1; height: 100%">
    <tt-tree-view ttSelectable="single" [(ttSelectedId)]="selectedId" (ttOnSelect)="onSelect($event)" [ttData]="tree" ttDataId="id" ttDataName="label" ttDataParentId="parentId"></tt-tree-view>

    <div #container class="viewer-container"></div>
</div> -->
<!-- <tt-do-data-imp [params]="{ dataimp_keyno: '2' }"></tt-do-data-imp> -->
<tt-card>
    <tt-checkbox ttLabel="show_critical_path" [(ttModel)]="showCriticalPath" [ttTrueValue]="true" [ttFalseValue]="false"></tt-checkbox>
    <tt-checkbox ttLabel="show_resource_graph" [(ttModel)]="showResourceGraph" [ttTrueValue]="true" [ttFalseValue]="false"></tt-checkbox>
</tt-card>
<tt-gantt ttRememberId="jlrtest.gantt" [(ttOptions)]="ganttOptions"></tt-gantt>
